import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult/index';
export interface IPopupProps {
    isOpen: boolean,
    title: JSX.Element | string | null,
    text?: JSX.Element | string | null,
    type?: EResultPopupStatus,
    isBalanceError?: boolean,
    onClose: () => void,
}

export const defaultResultPopupState: Omit<IPopupProps, 'onClose'> = {
    isOpen: false,
    title: null,
    type: EResultPopupStatus.DEFAULT,
    isBalanceError: false,
};

export type TDetailsType = 'packs' | 'subscriptions' | null;

export interface IDetailsState {
    isOpen: boolean,
    type: TDetailsType,
}

export const defaultDetailsState: IDetailsState = {
    isOpen: false,
    type: null,
};

export interface IPriceOptions {
    count: number,
    discount: number,
    price: number,
}

export enum ESectionId {
    packs = 'packs',
    subscriptions = 'subscriptions',
    services = 'services',
}

export type TPackageResponse = {
    success: boolean,
    code: string,
    message: string,
};
